import { render, staticRenderFns } from "./PayAndKickoff.vue?vue&type=template&id=616f8ae6&scoped=true&"
import script from "./PayAndKickoff.vue?vue&type=script&lang=js&"
export * from "./PayAndKickoff.vue?vue&type=script&lang=js&"
import style0 from "./PayAndKickoff.vue?vue&type=style&index=0&id=616f8ae6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616f8ae6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('616f8ae6')) {
      api.createRecord('616f8ae6', component.options)
    } else {
      api.reload('616f8ae6', component.options)
    }
    module.hot.accept("./PayAndKickoff.vue?vue&type=template&id=616f8ae6&scoped=true&", function () {
      api.rerender('616f8ae6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ClientDashboard/workspace/productEngagement/SignAgreement/PayAndKickoff.vue"
export default component.exports